angular.module('siter.io').factory 'Auth', ["Restangular", "$rootScope", "$stateParams", "$state", "$cookies", "User", "$q", "Site", "$translate", (Restangular, $rootScope, $stateParams, $state, $cookies, User, $q, Site, $translate) ->
  _ready = $q.defer()
  # Authorization service

  auth =
    # Check if user is logged in with promise
    isReadyLogged:  ->
      def = $q.defer()
      _ready.promise.then ->
        if window.justclick.currentUser
          def.resolve()
        else
          def.reject()
        return
      def.promise
    # Set token to all api requests
    setAuthHeaders: ->
      Restangular.setDefaultHeaders "X-AUTH-TOKEN": window.justclick.currentUser.authentication_token
    # Set headers and get current user
    check: ->
      @setAuthHeaders()
      User.me().then @checkSuccess, @checkFail
    # Setting user data to global scope variable
    setCurrentUser: (data) ->
      $rootScope.currentUser = data
      window.justclick.currentUser = data
    # Success logining
    checkSuccess: (dataMe) ->
      _ready.resolve()
      auth.setCurrentUser dataMe
      $translate.use(dataMe.lang).then ->
        $rootScope.$broadcast "translations:loaded"
      Restangular.setDefaultHeaders "X-AUTH-TOKEN": dataMe.authentication_token
      $cookies.put "auth_token", dataMe.authentication_token
      $rootScope.$broadcast "current:user"
    # Error in logining
    checkFail: ->
      _ready.resolve()
      return false if !$state.current.auth
      $state.go "public.home"
    # Go to projects if sites exists
    projects: (toSetup = false) ->
      $state.go "admin.dashboard.templates"
    auth: (credentials) ->
      # Login
      Restangular.all("users").all("login.json").post credentials
    register: (credentials) ->
      # Register
      Restangular.all("users.json").post credentials
    logout: ->
      # Exit
      document.location.href = window.justclick.back_uri
  auth
]



// WEBPACK FOOTER //
// ./src/app/public/login/login.service.coffee